import { logBadgeHistoryActionFunctionDef } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { getBadgeFileName } from '../../../../../ui/util/getBadgeFileName';
import { getBadgePrintLink } from '../../../../../ui/util/getBadgePrintLink';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useGeneratePdfReportDialog } from '@juvare/platform-sdk-react/ui/features/pdf-reports';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { Button } from '@mui/material';
import React from 'react';
export const PrintBadgeButton = ({ accountBadge }) => {
    const { t } = useBadgingTranslation();
    const generatePdfReportDialog = useGeneratePdfReportDialog();
    const logBadgeHistoryAction = useTypedPlatformFunction(logBadgeHistoryActionFunctionDef);
    const handlePdfDownload = () => {
        var _a;
        generatePdfReportDialog({
            components: [
                {
                    type: 'webpage',
                    url: getBadgePrintLink(`front-side/${accountBadge.id}`),
                    pageFormat: 'CR80',
                },
                {
                    type: 'webpage',
                    url: getBadgePrintLink(`back-side/${accountBadge.id}`),
                    pageFormat: 'CR80',
                },
            ],
            markPageNumbers: false,
        }, undefined, getBadgeFileName((_a = accountBadge.columns.accountDisplayName) !== null && _a !== void 0 ? _a : ''));
        logBadgeHistoryAction({
            accountBadgeIds: [accountBadge.id],
            badgeId: accountBadge.columns.badgeId,
            action: 'accountBadgePrinted',
        }).catch(handleErrorSnackbar);
    };
    return (React.createElement(Button, { startIcon: React.createElement(PrintOutlinedIcon, null), variant: 'text', size: 'small', onClick: handlePdfDownload, sx: {
            whiteSpace: 'nowrap',
        } }, t('badges.badgeDetails.accountBadgeTable.actions.print')));
};
